export const getActiveUser = (vueThis) => {
  return vueThis.$store.state.user
    ? vueThis.$store.state.user
    : vueThis.publicUser;
};

export const userHasAllRights = (neededRights, vueThis) => {
  let hasAll = true;

  //auto allow all rights on myspace
  /*if (!vueThis.$route.path.includes("myspace")) {*/
  const activeUser = getActiveUser(vueThis);
  const role =
    vueThis.$store.state.role != null ? vueThis.$store.state.role.name : null;

  neededRights.forEach((right) => {
    if (
      activeUser.rights[right] == 0 ||
      (right === "Administrator" && role !== right) ||
      (right === "user" && role === null) ||
      (right === "!user" && role !== null)
    ) {
      hasAll = false;
    }
  });
  /*}*/
  return hasAll;
};

export const routerRights = (neededRights, rights, user) => {
  let hasAll = true;

  neededRights.forEach((right) => {
    if (rights[right] == 0 || (right === "user" && !user)) {
      hasAll = false;
    }
  });

  return hasAll;
};

export const userHasSomeRights = (neededRights, vueThis) => {
  return (
    neededRights.filter((right) => {
      const activeUser = getActiveUser(vueThis);

      return activeUser.rights[right] == 1;
    }).length > 0 || neededRights.length === 0 /*||
    !vueThis.$route.path.includes("myspace")*/
  );
};
